import React, { useState } from "react";
import "./selectindividualdrawdownmodal.scss";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import { addCommas, formattedDate } from "../../helpers/helpers";

const SelectIndividualDrawdownModal = (props) => {
  const { individualMembershipData } = props;
  const [selected, setSelected] = useState(
    props.memberships === undefined
      ? individualMembershipData.memberships.find(
          (membership) => membership.status === "unLocked",
        )
      : props.memberships?.memberships?.length &&
          props.memberships.memberships.length ===
            individualMembershipData.memberships.length &&
          !individualMembershipData.memberships.some(
            (membership) => membership.status === "locked",
          )
        ? individualMembershipData.memberships.find(
            (membership) => membership.status === "unLocked",
          )
        : props.memberships?.memberships?.length &&
            props.memberships.memberships.length !==
              individualMembershipData.memberships.length &&
            individualMembershipData.memberships.some(
              (membership) => membership.status === "locked",
            )
          ? props.memberships.memberships[0]
          : props.memberships,
  );
  function handleCheck(item) {
    setSelected(item);
  }

  return (
    <div className="dd-manage-membership-modal-container">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="dd-manage-membership-modal-body">
        <div className="dd-parent-heading d-none d-xl-flex d-lg-flex d-md-flex">
          <div>
            <p className="dd-heading mb-3">{props.modalTitle}</p>
            <span className="mb-3">You can select one pot at a time.</span>
          </div>
          <div className="dd-parent-total-value">
            <div className="dd-total-value-head">Total value</div>
            <span className="dd-total-value">
              £{addCommas(Math.trunc(individualMembershipData?.totalFund))}.
              <span className="eac-pot-value-small-digit">
                {(individualMembershipData?.totalFund % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>
            </span>
          </div>
        </div>
        <div className="d-block d-sm-none">
          <div>
            <p className="ddheading mb-3">{props.modalTitle}</p>
          </div>
          <div className="mb-3">You can select one pot at a time.</div>
          <div className="dd-parent-total-value">
            <div className="">Total value</div>
            <span className="">
              £{addCommas(Math.trunc(individualMembershipData?.totalFund))}.
              <span className="eac-pot-value-small-digit">
                {(individualMembershipData?.totalFund % 1)
                  .toFixed(2)
                  .substring(2)}
              </span>
            </span>
          </div>
        </div>
        {individualMembershipData.status === "locked" ||
        individualMembershipData?.memberships?.some(
          (membership) => membership.status === "locked",
        ) ? (
          <div className="dd-locked-text d-flex mt-3">
            <span className="dd-locked-pad">
              <Icons iconname="locked" variant="icon-sixteen-px" />
            </span>
            <p className="dd-locked-text-pad">
              One or more of your pots has a change underway and will reopen
              when your change is complete.
            </p>
          </div>
        ) : (
          ""
        )}
        <Row className="content-Gap">
          {individualMembershipData?.memberships?.map((item, index) => {
            return (
              <Col
                key={index}
                className={
                  individualMembershipData.status === "locked"
                    ? "dd-pot-items pot-lock mb-3"
                    : item.status === "locked"
                      ? "dd-pot-items pot-lock mb-3"
                      : selected?.membershipId === item.membershipId
                        ? "dd-pot-items mb-3 dd-pot-items-bg"
                        : "dd-pot-items mb-3"
                }
                xs={12}
                sm={12}
                md={3}
                lg={3}
                xl={3}
              >
                {individualMembershipData.status === "locked" ||
                item.status === "locked" ? (
                  <div className="manage-custom-checkbox dd-custom-checkbox-align text-end">
                    <Icons iconname="locked" variant="icon-sixteen-px" />
                  </div>
                ) : (
                  <CustomCheckbox
                    name="pot"
                    potId={index}
                    variantName="manage-custom-checkbox dd-custom-checkbox-align text-end"
                    onChange={() => handleCheck(item)}
                    defaultChecked={
                      selected?.membershipId === item.membershipId
                    }
                  />
                )}
                <p className="dd-pot-value-id">{item.membershipId}</p>
                <p className="dd-pot-value-head">{item.membershipName}</p>
                <p className="dd-pot-total-value">
                  £{addCommas(Math.trunc(item.totalFund))}.
                  <span className="eac-pot-value-small-digit">
                    {(item.totalFund % 1).toFixed(2).substring(2)}
                  </span>
                </p>
              </Col>
            );
          })}
        </Row>
        <span className="dd-corrected-date mb-3">
          Figures correct as of{" "}
          {formattedDate(individualMembershipData?.correctDate)}
        </span>
        <Row className="d-flex justify-content-between">
          <Buttons
            name="Cancel"
            className="secondary mt-3"
            handleClick={props.handleCloseButton}
          />
          <Buttons
            name="Continue"
            className="primary mt-3 me-4"
            handleClick={() =>
              props.handleContinueButton(
                selected.memberships !== undefined
                  ? individualMembershipData
                  : selected,
              )
            }
          />
        </Row>
      </div>
    </div>
  );
};

export default SelectIndividualDrawdownModal;
